<template>
    <main id="mainCtrl">
        <PricelistDialog ref="pricelistDialog" @updated="updateTable"/>
        <header>
            <button :disabled="disableUpdateBtn" @click.prevent="update(false)">
                Обновить
            </button>
        </header>

        <v-table id="medflexTable"
                 request-uri="medflex/getList"
                 pagesize="50"
                 ref="table">
            <template v-slot:header>
                <v-tr>
                    <v-th name="created_at" sort="created_at" width="90">
                        Создан
                    </v-th>
                    <v-th name="clinic_name" sort="clinic_name" minwidth="200">
                        Клиника МЕДФЛЕКС
                    </v-th>
                    <v-th name="clinic_doctu" sort="clinic_doctu" minwidth="200">
                        Клиника ДОКТУ
                    </v-th>
                    <v-th name="status" width="150">
                        Статус
                    </v-th>
<!--                    <v-th name="publish" width="100">-->
<!--                        Публиковать-->
<!--                    </v-th>-->
                    <v-th name="updated_at" sort="updated_at" width="90">
                        Обновлен
                    </v-th>
                </v-tr>
                <v-tr>
                    <v-th name="created_at" v-slot="{filter}">
                        <date-piker v-model="filter.value"/>
                    </v-th>
                    <v-th name="clinic_name" :debounce="true" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="clinic_doctu" :debounce="true" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="status" v-slot="{ filter }">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                ...v_s_convert(statuses)
                            ]'
                        ></v-select>
                    </v-th>
<!--                    <v-th/>-->
                    <v-th name="updated_at" v-slot="{filter}">
                        <date-piker v-model="filter.value"/>
                    </v-th>
                </v-tr>
            </template>
            <template v-slot:row="{ item, index }">
                <v-tr class="hover pointer"
                    :id="'mp-tr-' + item.id"
                    @click="(row, event) => handleRowClick(event, item, row)"
                >
                    <v-td name="created_at" highlight="*">
                        {{ item.created_at | formatDate }}
                    </v-td>
                    <v-td name="clinic_name">
                        <b>{{ item.clinic_name }}</b>
                        <template v-if="item.clinic_address && item.clinic_city">
                            <br>
                            <span>г. {{ item.clinic_city }}, {{ item.clinic_address }}</span>
                        </template>
                    </v-td>
                    <v-td name="clinic_doctu">
                        <template v-if="item.clinic">
                            <b>{{ item.clinic.name }}</b>
                            <template v-if="item.clinic.address && item.clinic.cityObj">
                                <br>
                                <span>г. {{ item.clinic.cityObj.name }}, {{ item.clinic.address }}</span>
                            </template>
                        </template>
                    </v-td>
                    <v-td name="status" highlight="*" align="center">
                       <span>{{ statuses[item.pricelist_status] }}</span>
                    </v-td>
<!--                    <v-td name="publish" align="center">-->
<!--                        <button style="padding: 0 3px;" @click.prevent="publish">-->
<!--                            <i class="far fa-check text-success"/>-->
<!--                        </button>-->
<!--                    </v-td>-->
                    <v-td name="updated_at" highlight="*">
                        {{ item.updated_at | formatDate }}
                    </v-td>
                </v-tr>
            </template>
        </v-table>
    </main>
</template>

<script>
import PricelistDialog from "@dialogs/pricelists/medflex/Pricelist";
    export default {
        components: {
            PricelistDialog
        },
        data: function () {
            return {
                disableUpdateBtn: false,
                statuses: {
                    '': '',
                    'NO_PRICELIST': 'Откл. в МФ',
                    'NOT_MATCHED': 'Не связан',
                    'PUBLISHED': 'Опубликован',
                },
            };
        },
        methods: {
            update(forceUpdate = false) {
                this.disableUpdateBtn = true;

                this.axios
                    .post('medflex/update', {forceUpdate: forceUpdate})
                    .then(response => {
                        if (response.data.status === 'success') {
                            this.$modal('Фид загружен, обновление прайслистов запущено',{
                                name: 'ОК',
                                callback: () => {
                                    this.disableUpdateBtn = false;
                                },
                            },{}, false, 'only-text-dialog');
                        } else {
                            this.$modal(response.data.status,{
                                name: 'Обновить еще раз',
                                callback: () => {
                                    this.update(true);
                                },
                            },{
                                name: 'ОК',
                                callback: () => {
                                    this.disableUpdateBtn = false;
                                }
                            }, true, 'only-text-dialog width-50-dialog');
                        }
                    })
            },
            handleRowClick(event, item, row) {
                row.startLoadingAnimation();

                this.$refs.pricelistDialog.show(item.id)
                    .then(() => row.stopLoadingAnimation())
                    .catch(() => row.stopLoadingAnimation());
            },
            updateTable() {
                this.$refs.table.update();
            }
        },
    }
</script>
